import {FormElementMixin} from 'extensions/ui-mixins/form-element/lib/form-element-mixin';
import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import stylesheet from './x-mord-group.scss?as=stylesheet';

// eslint-disable-next-line new-cap
export class ModifyOrderGroup extends FormElementMixin(LitElement) {
	static get styles () {
		return [stylesheet];
	}

	// eslint-disable-next-line max-lines-per-function
	static get properties () {
		return {
			baseSubtotal: {
				attribute: 'base-subtotal',
				type: Number
			},
			code: {
				type: String
			},
			descrip: {
				type: String
			},
			formattedBaseSubtotal: {
				attribute: 'formatted-base-subtotal',
				type: String
			},
			formattedPrice: {
				attribute: 'formatted-price',
				type: String
			},
			formattedSubtotal: {
				attribute: 'formatted-subtotal',
				type: String
			},
			hidePricing: {
				attribute: 'hide-pricing',
				type: Boolean
			},
			hideSplitShipments: {
				attribute: 'hide-split-shipments',
				type: Boolean
			},
			id: {
				type: String
			},
			image: {
				type: String
			},
			name: {
				type: String
			},
			subtotal: {
				type: Number
			}
		};
	}

	// eslint-disable-next-line max-lines-per-function
	constructor () {
		super();

		/**
		 * @type {number}
		 */
		this.baseSubtotal = 0;

		/**
		 * @type {string}
		 */
		this.code = '';

		/**
		 * @type {string}
		 */
		this.descrip = '';

		/**
		 * @type {string}
		 */
		this.formattedBaseSubtotal = '';

		/**
		 * @type {string}
		 */
		this.formattedPrice = '';

		/**
		 * @type {string}
		 */
		this.formattedSubtotal = '';

		/**
		 * @type {boolean}
		 */
		this.hidePricing = false;

		/**
		 * @type {boolean}
		 */
		this.hideSplitShipments = false;

		/**
		 * @type {string}
		 */
		this.id = '';

		/**
		 * @type {string}
		 */
		this.image = '';

		/**
		 * @type {string}
		 */
		this.name = '';

		/**
		 * @type {number}
		 */
		this.subtotal = 0;
	}

	// eslint-disable-next-line max-lines-per-function
	renderInnerForm () {
		const classes = {
			container: true
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="inner-container">
					<div class="info">
						<div class="image">
							<img src="${this.image}" loading="lazy" class="image-source" />
						</div>
						${this.renderInformation()}
					</div>
					<div class="details">
						<div class="actions">
							<div class="slots">
								<slot></slot>
							</div>
							${this.hideSplitShipments ? nothing : html`<button type="submit" class="split-shipments-button" @click="${this.handleSplitShipment}">Split Shipments</button>`}
						</div>
						<div class="details-right">
							<div class="pricing-label">Subtotal</div>
							<div class="pricing">
								${this.renderPricing()}
							</div>
						</div>
					</div>
				</div>
			</div>
		`;
	}

	renderInformation () {
		return html`
			<div class="info-name">
				${this.descrip ? html`<div class="name">${this.descrip}</div>` : nothing}
				<div class="code">${this.code}</div>
			</div>
		`;
	}

	renderPricing () {
		if (!this.hidePricing) {
			return html`
				<div class="pricing-subtotal">
					${this.formattedSubtotal}
				</div>
				<div class="pricing-each">
					${this.formattedPrice} ea
				</div>
			`;
		}

		return html`
			<div class="pricing-subtotal">
				<span class="hide-pricing"></span>
			</div>
		`;
	}

	setLoading () {
		this.loading = true;
	}

	handleSplitShipment () {
		const newItem = document.createElement('x-mord-item');
		newItem.code = this.code;
		newItem.id = this.id;

		this.shadowRoot?.host?.appendChild(newItem);
	}
};

defineCustomElement('x-mord-group', ModifyOrderGroup);
